import { api } from 'config'

export const ADMINS_URL = {
   default: `${api.public}v1/admin/`,
   getAdmins: `${api.public}v1/admin/`,
   removeAdmin: `${api.public}v1/admin`,
   getAdmin: `${api.public}v1/admin`,
   editAdmin: `${api.public}v1/admin`
}
